import myoshLogoSquare from './myosh-logo-square.svg';
import myoshLogo from './myosh-logo.svg';

export const Logo = { myoshLogoSquare, myoshLogo };
